export default "__VITE_ASSET__D$X_IwP1__"